import { render } from "./AccountSubcontainer1.vue?vue&type=template&id=6bb33a5e&scoped=true"
import script from "./AccountSubcontainer1.vue?vue&type=script&lang=js"
export * from "./AccountSubcontainer1.vue?vue&type=script&lang=js"

import "./AccountSubcontainer1.vue?vue&type=style&index=0&id=6bb33a5e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6bb33a5e"

export default script